module.exports = __webpack_public_path__ + "static/media/form-completed.d66021ca.webp";